import styled from 'styled-components'
import {
  SelectMultipleWrapper,
  SelectMultipleRelativeWrapper,
} from './SelectMultipleUsers'
import type { AllSalaryCodesQuery, SalaryCodeNode } from '@/modules/companies'
import type { SelectMultipleOnSelectAll } from './SelectMultiple'
import { SelectMultiple } from './SelectMultiple'
import { useMemo, useState } from 'react'
import { useTranslate } from '@ur-solutions/react-hooks'
import { useQuery } from '@apollo/client'
import { ALL_SALARY_CODES_QUERY } from '@/modules/companies'

const SalaryCode = styled.div`
  display: flex;
  align-items: center;

  span.name {
    margin-left: 0.6rem;
  }
`

export interface SelectMultipleLeaderGroupsProps {
  selected: string[]
  onChange: (ids: string[]) => void
  compact?: boolean
  grayed?: boolean
  width?: string
  minWidth?: string
  error?: string | null
  onSelectAll?: SelectMultipleOnSelectAll
  isDirect?: boolean
}

export const SelectMultipleSalaryCodes: React.FC<
  SelectMultipleLeaderGroupsProps
> = ({
  selected,
  compact = true,
  width = '300px',
  minWidth,
  grayed = true,
  // TODO unused?
  isDirect: _isDirect = false,
  error,
  onChange,
  onSelectAll,
  ...props
}) => {
  const [open, setOpen] = useState<boolean>(false)

  const translations = useTranslate({
    nSalaryCodes: ['settings.n-salary-codes', { n: 0 }],
    selectSalaryCodes: 'common.select-salary-codes',
  })

  const { data: salaryCodesData } = useQuery<AllSalaryCodesQuery>(
    ALL_SALARY_CODES_QUERY
  )

  const salaryCodes = useMemo(
    () =>
      salaryCodesData?.allSalaryCodes?.edges
        ?.filter(edge => edge?.node)
        ?.map(edge => edge?.node) ?? [],
    [salaryCodesData]
  )

  const options = useMemo(() => {
    return salaryCodes.map((code: SalaryCodeNode) => ({
      value: code.id,
      label: (
        <SalaryCode>
          <span className="name">{code.name}</span>
        </SalaryCode>
      ),
    }))
  }, [salaryCodes])

  const selectedCount = selected.length
  const numSelectedText = translations.nSalaryCodes({ n: selectedCount })

  if (options.length === 0) {
    return null
  }

  return (
    <SelectMultipleRelativeWrapper width={width}>
      <SelectMultipleWrapper
        open={open}
        numSelectedText={numSelectedText}
        compact={compact}
        width={width}
      >
        <SelectMultiple
          onOpen={() => setOpen(true)}
          onClose={() => setOpen(false)}
          selected={selected}
          options={options}
          onChange={onChange}
          searchable="custom"
          onSelectAll={onSelectAll}
          fullWidth
          grayed={grayed}
          error={error}
          minWidth={minWidth}
          placeholder={translations.selectSalaryCodes}
          {...props}
        />
      </SelectMultipleWrapper>
    </SelectMultipleRelativeWrapper>
  )
}
